import { render, staticRenderFns } from "./SendJoinInvitesOverview.vue?vue&type=template&id=7228b1b1&scoped=true"
import script from "./SendJoinInvitesOverview.vue?vue&type=script&lang=js"
export * from "./SendJoinInvitesOverview.vue?vue&type=script&lang=js"
import style0 from "./SendJoinInvitesOverview.vue?vue&type=style&index=0&id=7228b1b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228b1b1",
  null
  
)

export default component.exports